import React from 'react';
import { Table, Popconfirm, Flex, Button } from 'antd';

import { TableCol } from './getTableCol';

import { planStruct } from './struct';
import { getRandomId } from '../../../../../../utilities/randomId';
import { getAsNumber } from '../../../../../../utilities/numberConvertion';

export const Plan = ({ planing, handlePlaning }) => {
  const handleAdd = () => {
    const newPlaning = {
      key: getRandomId(),
      detail: '',
      number_of_ra: 0
    };
    handlePlaning([...planing, newPlaning]);
  };

  const handleSave = (row) => {
    const currentOutcome = [...planing];
    const index = currentOutcome.findIndex((item) => row.key === item.key);
    const item = currentOutcome[index];

    row.number_of_ra = getAsNumber(row.number_of_ra);

    currentOutcome.splice(index, 1, {
      ...item,
      ...row
    });
    handlePlaning(currentOutcome);
  };

  const handleDelete = (key) => {
    const newData = planing.filter((item) => item.key !== key);
    handlePlaning(newData);
  };

  const columns = [
    ...TableCol(handleSave),
    {
      title: 'Action',
      dataIndex: 'operation',
      render: (_, record) => (
        <Popconfirm
          title="Sure to delete?"
          onConfirm={() => handleDelete(record.key)}
        >
          <a>Delete</a>
        </Popconfirm>
      )
    }
  ];

  return (
    <>
      <Table {...planStruct.table} columns={columns} dataSource={planing} />
      <br />
      <Flex {...planStruct.actionSection}>
        <Button className="glow-btn" onClick={handleAdd}>Add New Item</Button>{' '}
      </Flex>
    </>
  );
};
